import React, {  } from 'react';
import { PaymentCallbackDetails } from '../../logic/components';

const PaymentCallbackRoute = () => {
  return (
      <PaymentCallbackDetails/>
  );
};

export default PaymentCallbackRoute;
